import BreakoutModuleMid from './BreakoutModuleMid'

export default BreakoutModuleMid
